import createClient from './createClient';
// @ts-ignore
import SNABBLE_BASE_URL from './snabbleBaseUrl';

export default createClient({
  baseURL: SNABBLE_BASE_URL,
});
